<template>
	<div>
		<nav
			class="flex justify-between items-center flex-wrap bg-white px-4 py-2 lg:px-6 lg:py-2 border-b border-amp-border"
		>
			<div
				class="flex items-center flex-no-shrink text-amp-text mr-6 cursor-pointer"
			>
				<svg
					class="fill-current h-6 w-6 mr-2"
					width="54"
					height="54"
					viewBox="0 0 54 54"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M13.5 22.1c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05zM0 38.3c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05z"
					/>
				</svg>
				<span class="font-semibold text-lg xs:text-xs tracking-tight">
					NymbleUp
				</span>
			</div>
			<div class="block lg:hidden" @click="toggleMenu = !toggleMenu">
				<button
					class="flex items-center
            px-3 py-2 border border-rounded
            text-amp border-amp
            hover:text-amp-btn2 hover:border-amp-btn2
            focus:outline-none"
				>
					<svg
						class="fill-current h-3 w-3"
						viewBox="0 0 20 20"
						xmlns="http://www.w3.org/2000/svg"
					>
						<title>Menu</title>
						<path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
					</svg>
				</button>
			</div>
			<!-- desktop version -->
			<div class="hidden flex-grow lg:flex lg:items-center lg:w-auto">
				<div class="text-xs lg:flex-grow">
					<div class="relative lg:inline-block lg:mt-0 mr-4">
						<div
							class="flex items-center  text-amp-text hover:text-amp-hover"
							@click="toggleProducts = !toggleProducts"
						>
							<a
								href="#"
								class="block mt-4 lg:mt-0 text-amp-text hover:text-amp-hover"
							>
								Products
							</a>
							<span class="pt-2 pl-1 cursor-pointer">
								&#65088;
							</span>
						</div>
						<div
							v-if="toggleProducts"
							v-outside-click="hideProductsDropdown"
							class="absolute z-10 w-40 flex flex-col py-2 px-4 bg-white mt-4 text-amp-text rounded shadow-md"
						>
							<a
								href=""
								class="text-amp-text hover:text-amp-hover py-1 cursor-pointer text-xs"
							>
								Sales Forecast
							</a>
							<a
								class="text-amp-text hover:text-amp-hover py-1 cursor-pointer text-xs"
							>
								Inventry management
							</a>
							<a
								class="text-amp-text hover:text-amp-hover py-1 cursor-pointer text-xs"
							>
								Expiry Management
							</a>
							<a
								class="text-amp-text hover:text-amp-hover py-1 cursor-pointer text-xs"
							>
								Products
							</a>
						</div>
					</div>
					<a
						href=""
						class="block mt-4 lg:inline-block lg:mt-0 text-amp-text hover:text-amp-hover mr-4"
					>
						Customers
					</a>
					<a
						href=""
						class="block mt-4 lg:inline-block lg:mt-0 text-amp-text hover:text-amp-hover mr-4"
					>
						Resources
					</a>
					<a
						href=""
						class="block mt-4 lg:inline-block lg:mt-0 text-amp-text hover:text-amp-hover"
					>
						About Us
					</a>
				</div>
			</div>

			<div class="lg:flex hidden">
				<a
					class="block px-4 py-2.5 leading-none border border-amp cursor-pointer hover:bg-amp-light font-bold text-xs rounded bg-amp text-white mt-4 lg:mt-0 lg:mr-4"
					@click="openFreeTrialModel()"
				>
					START FREE TRIAL
				</a>
				<a
					class="block px-4 py-2.5 leading-none border border-amp-btn2 bg-amp-btn2 cursor-pointer hover:text-amp-hover-dark hover:bg-amp-btn2-light hover:border-amp-btn2-light font-bold text-xs rounded text-white mt-4 lg:mt-0  text-center"
					@click="openLoginModel()"
				>
					LOGIN
				</a>
			</div>

			<!-- mobile version -->
			<div v-if="toggleMenu" class="lg:hidden block w-full ">
				<div class="text-sm lg:flex-grow">
					<div class="relative lg:inline-block lg:mt-0 mr-4">
						<div
							class="flex items-center  text-amp-text hover:text-amp-hover"
							@click="toggleProducts = !toggleProducts"
						>
							<a
								href="#"
								class="block mt-4 lg:mt-0 text-amp-text hover:text-amp-hover"
							>
								Products
							</a>
							<span class="pt-2 mt-4 pl-1 cursor-pointer">
								&#65088;
							</span>
						</div>
						<div
							v-if="toggleProducts"
							v-outside-click="hideProductsDropdown"
							class=" w-full flex flex-col py-1 px-4 bg-white text-amp-text "
						>
							<a class="hover:text-amp-hover py-1 cursor-pointer text-xs">
								Sales Forecast
							</a>
							<a class="hover:text-amp-hover py-1 cursor-pointer text-xs">
								Inventry management
							</a>
							<a class="hover:text-amp-hover py-1 cursor-pointer text-xs">
								Expiry Management
							</a>
							<a class="hover:text-amp-hover py-1 cursor-pointer text-xs">
								Products
							</a>
						</div>
					</div>
					<a
						href="#"
						class="block mt-4 lg:inline-block lg:mt-0 text-amp-text hover:text-amp-hover mr-4"
					>
						Customers
					</a>
					<a
						href="#"
						class="block mt-4 lg:inline-block lg:mt-0 text-amp-text hover:text-amp-hover"
					>
						Resources
					</a>
					<a
						href="#"
						class="block mt-4 lg:inline-block lg:mt-0 text-amp-text hover:text-amp-hover"
					>
						About Us
					</a>
				</div>
			</div>
			<div v-if="toggleMenu" class="lg:hidden block">
				<a
					href="#"
					class="block px-4 py-2 leading-none border border-amp hover:bg-amp-light font-bold text-xs rounded bg-amp text-white mt-4"
				>
					START FREE TRIAL
				</a>
				<a
					href="#"
					class="block px-4 py-2 leading-none rounded border border-amp-btn2 bg-amp-btn2 hover:text-amp-hover-dark hover:bg-amp-btn2-light hover:border-amp-btn2-light font-bold text-xs mt-4 text-white text-center"
				>
					LOGIN
				</a>
			</div>
		</nav>
		<LoginAndFreeTrial v-if="showLoginModel" />
	</div>
</template>

<script>
export default {
	data() {
		return {
			toggleMenu: false,
			toggleProducts: false
		};
	},
	computed: {
		showLoginModel() {
			// Whenever $store.state.show_login_and_freeTrial_model changes, it will cause the computed property to re-evaluate, and trigger associated DOM updates.
			return this.$store.state.show_login_and_freeTrial_model;
		}
	},
	methods: {
		hideProductsDropdown() {
			this.toggleProducts = false;
		},
		openLoginModel() {
			this.$store.commit("showFreeTrialModel", false);
			this.$store.commit("openLoginModel", true);
		},
		openFreeTrialModel() {
			this.$store.commit("showFreeTrialModel", true);
			this.$store.commit("openLoginModel", true);
		}
	}
};
</script>

<style lang="scss" scoped>
a {
	text-decoration: none;
}
</style>
